import { useSessionTracking } from '@/hooks/useSessionTracking';

/**
 * Component that tracks site visits. 
 * Renders nothing but runs the session tracking hook.
 */
export function SessionTracker() {
  useSessionTracking();
  return null;
}
